module.exports = __webpack_public_path__ + "static/img/hua6.4780d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua6.png
// module id = Czok
// module chunks = 22